import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../hooks/useApiClient";
import { Components } from "../schema/openapi";

export type MetadataResponse = Components.Schemas.MetadataResponse;

export const MetadataQueryKey = ["metadata"] as const;

export const useGetMetadata = () => {
  const client = useApiClient();

  return useQuery({
    queryKey: MetadataQueryKey,
    queryFn: async (): Promise<MetadataResponse> =>
      await client.getMetadata().then((res) => res.data),
    staleTime: 1 * 30 * 1000, // 30 seconds
  });
};
